import React from 'react';
import bannersModule, { BannerTypes } from '@gin-betting/banners';

import Banner from '../Banner';
import useBanners from './useBanners';

const {
    hocs: { withAvailableZoneByAttributes },
} = bannersModule;

interface OwnProps {
    zoneLocation: BannerTypes.BannerZoneLocation;
}

type Props = OwnProps & BannerTypes.WithAvailableZoneProps;

const Banners: React.FC<Props> = React.memo(({ zoneId, zoneLocation }) => {
    const { banners } = useBanners({ zoneId });

    return (
        <React.Fragment>
            {banners.map((banner, idx) => (
                <Banner key={idx} banner={banner} zoneLocation={zoneLocation} />
            ))}
        </React.Fragment>
    );
});

export default withAvailableZoneByAttributes<Props>(Banners);
